import { useMemo } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import data from '../sample/data';

function BlogDetailPage() {
  const { id } = useParams();
  const post = useMemo(() => data.blogs.find(b => b.id === id), [id]);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <div className="space-y-6 px-4 md:px-8">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight">{post.title}</h1>
        <Link
          to="/blog"
          className="text-sm text-accent hover:underline mt-2 md:mt-0"
        >
          Back to Blog
        </Link>
      </div>

      <div className="flex items-center gap-3 flex-wrap text-xs text-foreground/70">
        <span>{post.date ? new Date(post.date).toLocaleDateString() : ''}</span>
        <div className="flex gap-2 flex-wrap">
          {(post.tags || []).map(tag => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-full bg-white/10 border border-white/10 text-xs"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      <img
        src={post.image}
        alt={post.title}
        className="w-full h-72 md:h-96 object-cover rounded-xl border border-white/10"
      />

      <div className="prose max-w-none text-foreground/90 text-base space-y-4">
        {post.content.split('\n\n').map((paragraph, idx) => (
          <p key={idx}>{paragraph}</p>
        ))}
      </div>
    </div>
  );
}

export default BlogDetailPage;
